import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    edge: { type: String, default: "left" },
    threshold: { type: Number, default: 75 },
    edgeWidth: { type: Number, default: 20 }
  }

  connect() {
    this.touchStartX = 0
    this.touchStartY = 0
    this.isEdgeTouch = false

    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.handleTouchEnd = this.handleTouchEnd.bind(this)

    document.addEventListener("touchstart", this.handleTouchStart, { passive: true })
    document.addEventListener("touchmove", this.handleTouchMove, { passive: false })
    document.addEventListener("touchend", this.handleTouchEnd, { passive: true })
  }

  disconnect() {
    document.removeEventListener("touchstart", this.handleTouchStart)
    document.removeEventListener("touchmove", this.handleTouchMove)
    document.removeEventListener("touchend", this.handleTouchEnd)
  }

  handleTouchStart(event) {
    const touch = event.touches[0]
    this.touchStartX = touch.clientX
    this.touchStartY = touch.clientY

    const screenWidth = window.innerWidth
    const isLeftEdge = touch.clientX < this.edgeWidthValue
    const isRightEdge = touch.clientX > screenWidth - this.edgeWidthValue

    this.isEdgeTouch = (this.edgeValue === "left" && isLeftEdge) ||
                       (this.edgeValue === "right" && isRightEdge) ||
                       (this.edgeValue === "both" && (isLeftEdge || isRightEdge))
  }

  handleTouchMove(event) {
    if (!this.isEdgeTouch) return

    const touch = event.touches[0]
    const deltaX = touch.clientX - this.touchStartX
    const deltaY = Math.abs(touch.clientY - this.touchStartY)

    if (deltaY > Math.abs(deltaX)) {
      this.isEdgeTouch = false
      return
    }

    if (Math.abs(deltaX) > 10) {
      event.preventDefault()
    }
  }

  handleTouchEnd(event) {
    if (!this.isEdgeTouch) return

    const touch = event.changedTouches[0]
    const deltaX = touch.clientX - this.touchStartX
    const deltaY = Math.abs(touch.clientY - this.touchStartY)

    if (deltaY < Math.abs(deltaX) && Math.abs(deltaX) > this.thresholdValue) {
      const direction = deltaX > 0 ? "right" : "left"
      const validSwipe = (this.edgeValue === "left" && direction === "right") ||
                         (this.edgeValue === "right" && direction === "left") ||
                         (this.edgeValue === "both")

      if (validSwipe) {
        this.dispatch("swipe", { detail: { direction } })
      }
    }

    this.isEdgeTouch = false
  }
}
